<template>
    <nav class="c-m-menu-mobile no-print" id="header-nav">
        <ul class="c-m-menu-mobile__list c-m-menu-mobile__list--level-0">
            <li class="c-m-menu-mobile__item" v-if="isAuthenticated && user && isMounted">
                <router-link class="c-m-menu-mobile__link" :to="{ path: '/mina-sidor/' }">
                    <icon :icon="'account_circle'"></icon>
                    Mina sidor
                </router-link>
            </li>
            <li class="c-m-menu-mobile__item c-m-menu-mobile__item--log-out" v-if="isAuthenticated && user && isMounted">
                <div class="c-m-menu-mobile__link" @click="handleLogOut">
                    <icon :icon="'power_off'"></icon>
                    Logga ut - {{user.userName}}
                </div>
            </li>
            <li class="c-m-menu-mobile__item" v-else>
                <router-link class="c-m-menu-mobile__link" :to="{ path: '/logga-in/' }">
                    <icon :icon="'person'"></icon>
                    Logga in
                </router-link>
            </li>
            <li class="c-m-menu-mobile__item" v-if="contactWidget">
                <router-link class="c-m-menu-mobile__link" :to="`/info/${contactWidget.contact_page.post_name}/`">
                    <icon :icon="'phone'"></icon>
                    Kontakta oss
                </router-link>
            </li>
            <li v-if="queuedCompanies.length > 0 && isMounted" class="c-m-menu-mobile__item c-m-menu-mobile__item--queued-companies">
                <queue class="c-m-queued-companies--smooth-corners c-m-queued-companies--shadow"></queue>
            </li>
            <menu-item-mobile v-for="(item, key) in items" :key="`mobile-menu-${key}-${item.title}`" :item="item" :level="0"></menu-item-mobile>
            <li class="c-m-menu-mobile__item c-m-menu-mobile__item--cta">
                <router-link class="c-m-menu-mobile__link" v-if="!isCompany" :to="{name: 'Hem (Hantverkare)'}">
                    <icon :icon="'hammer_and_wrench'"></icon>
                    Anslut ditt företag
                </router-link>
                <router-link class="c-m-menu-mobile__link" v-else :to="{name: 'Hem'}">
                    Är du beställare?
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    import { GET_COMPANIES } from '../../../store/store-models/queued-companies-model';
    import { GET_CONTACT_WIDGET } from '../../../store/store-models/meta-model.js';
    import { GET_USER, IS_AUTHENTICATED, LOG_OUT } from '../../../store/store-models/authentication-model';

    import MenuItemMobile from './MoleculeMenuItemMobile.vue';
    import Icon from '../atoms/AtomIcon.vue';
    import Queue from '../molecules/MoleculeQueuedCompanies.vue';

    export default {
        components: {
            MenuItemMobile,
            Icon,
            Queue
        },
        data() {
            return {
                isMounted: false
            }
        },
        props: {
            isCompany: {
                type: Boolean,
                default: false
            },
            items: {
                type: Array,
                default: () => ([])
            }
        },
        computed: {
            ...mapGetters({
                contactWidget: GET_CONTACT_WIDGET,
                queuedCompanies: GET_COMPANIES,
                isAuthenticated: IS_AUTHENTICATED,
                userData: GET_USER
            }),
            user: function() {
                if(this.userData && Object.keys(this.userData).length > 0 ) {
                    return this.userData
                }

                return false
            }
        },
        methods: {
            ...mapActions({
                logOut: LOG_OUT
            }),
            async handleLogOut() {
                await this.logOut();
                this.$router.push({name: 'Logga in'});
            }
        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeMenuMobile.vue